import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fdf6dfc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0fdf6dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf6dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdf6dfc')) {
      api.createRecord('0fdf6dfc', component.options)
    } else {
      api.reload('0fdf6dfc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fdf6dfc&scoped=true&", function () {
      api.rerender('0fdf6dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BusinessComponent/OpSelect/index.vue"
export default component.exports